import { zonedTimeToUtc } from 'date-fns-tz';

/**
 * Caclulate distnace between the 2 points .(latlng Point)
 * @param p_1 point 1 .
 * @param p_2 point 2 .
 * @returns The distnace between the 2 points .
 */
export function distanceBetween2Coordinates(p_point,p_path_point){

    const lon1 =  p_point.lng * Math.PI / 180;
    const lon2 = Number(p_path_point.point.x) * Math.PI / 180;
    const lat1 = p_point.lat * Math.PI / 180;
    const lat2 = Number(p_path_point.point.y) * Math.PI / 180;
  
    // console.log(lon1 , lon2 ,lat1 ,lat2);
  
    // Haversine formula
    let dlon = lon2 - lon1;
    let dlat = lat2 - lat1;
    let a = Math.pow(Math.sin(dlat / 2), 2)
              + Math.cos(lat1) * Math.cos(lat2)
              * Math.pow(Math.sin(dlon / 2),2);
            
    let c = 2 * Math.asin(Math.sqrt(a));
  
    // Radius of earth in kilometers. Use 3956
    // for miles
    let r = 6371;
  
    // calculate the result
    return(c * r);
  }
  
  /**
   * Caclulate the nearest point at path array .
   * @param p_point clicked point on path .
   * @param p_path clicked path
   * @returns in the index of nearest point at path to clicked point .
   */
  
  export function getNearestPoint(p_point,p_path){
  
    let minimumDistance = Number.MAX_VALUE;
    let indexToReturn = -1;
  
    
    // calculate distances from point to each polyline point
    for (let i = 0; i < p_path.length - 1; i++) {
      const currentDistance = distanceBetween2Coordinates(p_point , p_path[i]);
      if(currentDistance < minimumDistance){
        minimumDistance = currentDistance;
        indexToReturn = i;
      }
    }
  
  
    // return index at array, which has shortest distance
    return indexToReturn;
  }
  
  

    /**
   * Find tasks in paths array.
   * @param p_paths paths list.
   * @returns tasks array.
   */
  
  
    export const buildTasksArray = (p_paths) => {
      const tasksArray = [];
    
      p_paths.forEach((p_path, pathIndex) => {  // Loop over paths and track the pathIndex
        // Add safety checks for the path structure
        const pathPoints = p_path?.path?.points;
        if (!pathPoints || !Array.isArray(pathPoints)) {
          console.warn('buildTasksArray - Invalid path structure:', p_path);
          return; // Skip this path if it doesn't have valid points
        }
        
        pathPoints.forEach((p_point, pointIndex) => {  // Loop over points and track the pointIndex
          if (p_point.task_json !== undefined && p_point.task_json !== "") {
            let parsedTaskJson;
            if (typeof p_point.task_json === "string") {
              parsedTaskJson = JSON.parse(p_point.task_json);
            } else {
              parsedTaskJson = p_point.task_json;
            }
    
            if (Array.isArray(parsedTaskJson)) {
              // Group tasks by the point's position
              const taskGroup = {
                point: p_point,
                pointIndex,  // Add pointIndex
                tasks: parsedTaskJson.map((p_task) => ({ ...p_task })),
              };
    
              tasksArray.push(taskGroup);
            }
          }
        });
      });
    
      return tasksArray;
    };
    
    
  
  export const buildPoisArrayFromMissionPaths = (p_paths,p_poisArray)=>{
    const poisArray = [];
    for (let p_path_index = 0; p_path_index < p_paths.length ; p_path_index++) {
        const p_path = p_paths[p_path_index];
        const poiToAdd = p_poisArray.find(p_poi => p_poi.poi_name === p_path.path.dest_name);
        if (poiToAdd !== undefined) {
              if(p_path_index === p_paths.length - 1){
                // Pushing to the start of the array
                // because the last path destinates to the start of the shuttle mission
                poisArray.unshift(poiToAdd);
              }else{
                poisArray.push(poiToAdd);
              }        
        }
    }
    return poisArray;
  }
  

export function convertPathPoitToLatLng(p_pathObj){
  if(!p_pathObj || !p_pathObj.point) return null;
  if(p_pathObj.point.x !== undefined && p_pathObj.point.y !== undefined){
    const y = parseFloat(p_pathObj.point.y);
    const x = parseFloat(p_pathObj.point.x);
    if(!isNaN(y) && !isNaN(x)) return [y,x];
  }
  return null;
}

export function formatedTrackPathtoLatLng(arr) {

    let resTrack = []
    let i =0;
    if (arr) {
        arr.forEach(pathObj => {
            i++;
            const latLng = convertPathPoitToLatLng(pathObj);
            if(latLng){
                resTrack.push(latLng);
            }
        });
    }
    return resTrack;

} 
 
export function formatedTrackPath(arr) {
  if (!Array.isArray(arr)) return [];
  const resTrack = [];
  arr.forEach((pathObj) => {
    if (!Array.isArray(pathObj) || pathObj.length < 2) return;
    const lng = Number(pathObj[0]);
    const lat = Number(pathObj[1]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
    resTrack.push([lat, lng]);
  });
  return resTrack;
}




export function calculateYawBetween2Points(p1,p2) {

  const x1 = p1.x;
  const y1 = p1.y;
  const x2 = p2.x;
  const y2 = p2.y;

  // Calculate the yaw angle
  const deltaX = x2 - x1;
  const deltaY = y2 - y1;

  const yawAngle = Math.atan2(deltaX, deltaY);

  // Convert yawAngle to degrees 
  const yawAngleDegrees = yawAngle * (180 / Math.PI);

  return yawAngleDegrees;
}



const moment = require('moment-timezone');



/**
 * Retrieves the current time of the site, adjusted to the specified time zone.
 * If no time zone is specified, it defaults to the local time zone.
 * 
 * @returns {Date} The current time of the site.
 */
export const siteCurrentTime = (site_time_zone)=>{
    let siteTime ;
    
    if(site_time_zone && site_time_zone !== undefined){
      const momentObj = moment.tz(site_time_zone);
      const year = momentObj.year();
      const month = momentObj.month();
      const day = momentObj.date();
      const hours = momentObj.hours();
      const minutes = momentObj.minutes();
      const seconds = momentObj.seconds();
      
      siteTime = new Date(year, month, day, hours, minutes, seconds);
      
    } else {
      siteTime = new Date();
  }

 
  return siteTime;
}
   

/**
 * Formats the given date object into the string format 'YYYY-MM-DD HH:mm:ss'.
 * @param {Date} date - The date object to format.
 * @returns {string} The formatted date string.
 */
export function formattedDate(date) {
  // Function to pad single digits with leading zeros
  const pad = (num) => {
    return num < 10 ? '0' + num : num;
  };

  // Construct the formatted date string
  const formattedDateString =
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    ' ' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds());

  return formattedDateString;
}
